// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__kKbv7","right":"styles_right__3nWcw"};